import { BetslipUtilChannels } from "../../dependencies";
/**
 * @class
 * @implements {BsUtilMsgRouter}
 * @classdesc External message bus integration for BetslipUtilChannels. Listen/Post messages through sbMsgBus.
 */
export class ExternalMsgRouter {
    constructor(msgBus) {
        this.msgBus = msgBus;
        this.listeners = {};
        Object.keys(BetslipUtilChannels.Listen.Commands).forEach(key => {
            this.listeners[`${this.msgBus.sbPrefix}${BetslipUtilChannels.Listen.Commands[key]}`] = key;
        });
    }
    attachListeners(onMessageReceived, context) {
        Object.keys(this.listeners).forEach(x => this.msgBus.subscribe(x, onMessageReceived.bind(context, this.listeners[x])));
    }
    detachListeners(onMessageReceived, context) {
        Object.keys(this.listeners).forEach(x => this.msgBus.unsubscribe(x, onMessageReceived.bind(context)));
    }
    sendMessage(channel, data) {
        let msg = {
            [`${this.msgBus.sbPrefix}${channel}`]: data
        };
        this.msgBus.post(msg);
    }
}
//# sourceMappingURL=ExternalMsgRouter.js.map